export {
  default,
  generateModalContext,
  ModalContextProvider,
  MockedModalContextProvider,
  useModalContext
} from './ModalContext';
